export const UserAddress = (address) => {
  const userAddress = address.slice(0, 4) + " ... " + address.slice(38, 42);
  return userAddress;
};
